// interface AddCustomerInterface {
//   CompanyName: string;
//   BillAddr: {
//     Line1: string;
//     City: string;
//     Country: string;
//     CountrySubDivisionCode: string;
//     PostalCode: string;
//   };
//   ShipAddr: {
//     Line1: string;
//     City: string;
//     Country: string;
//     CountrySubDivisionCode: string;
//     PostalCode: string;
//   };
//   Notes: string;
//   DisplayName: string;
//   PrimaryPhone: {
//     FreeFormNumber: string;
//   };
//   PrimaryEmailAddr: {
//     Address: string;
//   };
//   is_active: 1;
//   total_credit_line: string;
//   credit_line_balance: string;
//   qb_customer_id?: string;
//   SyncToken?: any;
// }

export const CreateCustomerInitialValues = {
  DisplayName: "",
  company_name: "",
  customerType: '',
  phoneNo: "",
  email: "",
  credit_line_balance: "0",
  total_credit_line: "0",
  address: "",
  city: "",
  state: '',
  zip: "",
  country: "",
  qb_customer_id: "",
  SyncToken: "",
  shippingName: '',
  shippingAddress: '',
  shippingCity: '',
  shippingState: '',
  shippingZip: '',

};
